import $ from 'jquery'
import ImportMedicament from '@/views/medicaments/importer-medicament'
import RecapStock from '@/views/recap-stock'
import RecapProduits from '@/components/recap-produits'
import store_medicaments from "@/store/mods/stock/medicaments"
import store_consommable from "@/store/mods/stock/consommables"
import { correspondRecherche } from '@/utils/catalogue-search'

export default {
    name: 'liste-consommable',
    components: {
        ImportMedicament, RecapStock, RecapProduits
    },
    props: [],
    data() {
        return {
            fields: [
                'num', 'produit', {key: 'peremption', label: 'Date péremption'}, 
                { key: 'seuil', label: 'Seuil (Min/Opt)' },
                'prix_cession', 'prix_public', 'qte_dsiponible', 'actions'
            ],
            print_fields: ['num', 'produit', 'peremption', 'prix_cession', 'prix_public', 'qte_dsiponible'],
            filter: "",
            perPage: 50,
            currentPage: 1,
            print_per_page: -1,
            can_delete_medicament: false,
            med_to_be_deleted: [],
            del_loading: false,
            is_confirm: false,
            is_printing: false,
            can_print: false,
            filename: '',

            is_loading: true,
            is_empty: false,

            json_fields: {
                'Id': 'id',
                'Libellé': 'libelle',
                'Seuil minimum': 'seuil_minimum',
                'Seuil optimal': 'seuil_optimal',
                'Prix public': 'prix_public',
                'Prix cession': 'prix_cession',
                'Famille': 'famille',
                'Qté disponible': 'qte_dsiponible'
            },

            json_data: [],
            export_filename: 'Liste_Consommables.xls',
            consommables: [],
            // STOCK-LABO : filtre par famille de consommable (Réactif, Contenant de prélèvement…)
            filtre_famille: '',
            familles_disponibles: [],
            consommables_filtres: [],

            recap_stock: [],
            recap_is_loading: false,

            modal_title: '',
            produits: [],
            modal_toggler: 0,
            has_day: false,

            c_loading_percentage: 0,
            can_view_percentage: false,
            c_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
        }
    },

    computed: {
        consommables_recherche() {
            return this.consommables_filtres.filter(consommable =>
                correspondRecherche([consommable.libelle, consommable.lot_article, consommable.famille], this.filter)
            )
        },

        consommables_groupes() {
            const debut = (this.currentPage - 1) * this.perPage
            const groupes = new Map()
            this.consommables_recherche.slice(debut, debut + this.perPage).forEach((consommable, index) => {
                const famille = String(consommable.famille || '').trim() || 'Sans famille'
                if (!groupes.has(famille)) groupes.set(famille, [])
                groupes.get(famille).push({ ...consommable, numero_affichage: debut + index + 1 })
            })
            return Array.from(groupes, ([famille, produits]) => ({ famille, produits }))
                .sort((a, b) => a.famille.localeCompare(b.famille, 'fr'))
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        }, 

        activeRole() {
            return this.$store.getters["activeRole"];
        },
    },

    watch: {
        filter() { this.currentPage = 1 },
        perPage() { this.currentPage = 1 },
    },
    beforeDestroy() {
        if (this.c_refresh_timeout_id) {
            clearTimeout(this.c_refresh_timeout_id)
            this.c_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

    mounted() {
        this.$store.commit("SET_LOT_ARTICLE_REF_ID", null)
        this.getListConsommable()

        if (this.userCredentials.user.roles.length > 0) {
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.user_role == 'ROLE_ADMINISTRATEUR') {
                this.can_delete_medicament = true
            }
        }
        var d = new Date()
        var tmpstamp = d.getHours() + '' + d.getMinutes() + '' + d.getFullYear()
        this.filename = 'Liste_des_consommables_' + tmpstamp

        this.getRecapStock() 
    },

    methods: {
        countdownLoad() {
            const TOTAL_SECONDS = 12 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.c_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.c_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.c_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeConsommables() {
            this.is_loading = true
            this.can_view_percentage = true
            if (this.c_refresh_timeout_id) {
                clearTimeout(this.c_refresh_timeout_id)
                this.c_refresh_timeout_id = null
            }

            if (this.consommables.length > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.getListConsommable()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.getListConsommable()
            this.c_refresh_timeout_id = setTimeout(() => {
                this.refreshListeConsommables()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeConsommables()
        },

        /** STOCK-LABO : familles présentes dans la liste, puis application du filtre. */

        appliquerFiltreFamille() {

            this.currentPage = 1

            const familles = []

            this.consommables.forEach(consommable => {

                const famille = consommable.famille ? String(consommable.famille) : ''

                if (famille && familles.indexOf(famille) < 0) familles.push(famille)

            })

            familles.sort((a, b) => a.localeCompare(b))

            this.familles_disponibles = familles

            if (this.filtre_famille && familles.indexOf(this.filtre_famille) < 0) this.filtre_famille = ''

            this.consommables_filtres = this.filtre_famille

                ? this.consommables.filter(consommable => String(consommable.famille || '') === this.filtre_famille)

                : this.consommables

        },


        getListConsommable() {
            this.is_loading = true
            store_consommable.getListeConsommables().then((response) => {
                this.consommables = response
                this.appliquerFiltreFamille()
                if (this.consommables.length > 0) {
                    this.is_empty = false

                    this.consommables.forEach(consommable => {
                        this.json_data.push({
                            'id': consommable.id,
                            'libelle' : consommable.libelle,
                            'famille': consommable.famille || '',
                            'seuil_minimum': (consommable.minimum > 0)?consommable.minimum:'', 
                            'seuil_optimal': (consommable.optimale > 0)?consommable.optimale:'', 
                            'prix_public': (consommable.prix > 0)?consommable.prix:'',
                            'prix_cession': (consommable.prix_cession > 0)?consommable.prix_cession:'',
                            'qte_dsiponible': (consommable.qte_dsiponible > 0)?consommable.qte_dsiponible:''
                        })
                    });
                } else {
                    this.is_empty = true
                }
                
                if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.is_loading = false
                    }
                } else {
                    this.is_loading = false
                }
            })
        },

        /**
         * Medicament à supprimer
         */
        med_to_delete(medicament) {
            let libelle = medicament.libelle + ' '


            this.med_to_be_deleted = {
                user_id: this.userCredentials.user.id,
                id: medicament.id,
                libelle: libelle
            }
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        deleteMedicament() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del-conso');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteMedicament', this.med_to_be_deleted).then((response) => {
                    if (response > 0) {

                        this.$store.dispatch("getConsommables");

                        $('.modal').modal('hide')

                        this.successMedicamentDeleted()
                    } else {
                        this.errorMedicamentDeletion()

                        $('.modal').modal('hide')

                    }
                    this.del_loading = false;
                    this.is_confirm = false

                })
            }
        },

        successMedicamentDeleted: function () {
            this.$toasted.show('Consommable supprimé avec succès', {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        errorMedicamentDeletion: function () {
            this.$toasted.show('Une erreur s\'est produite !', {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                type: 'error'

            })
        },

        handleBeforeGenerate() {
            let d = new Date()
            this.export_filename = 'Liste_Consommables_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        getRecapStock() {
            this.recap_is_loading = true
            const data = {
                type_article_id: 2,
            }
            store_medicaments.getRecapStock(data).then((response) => {
                this.recap_stock = response

                this.recap_is_loading = false
            })
        },

        goToRecapStock(articles, has_day, modal_title) {
            this.modal_title = modal_title
            this.produits = articles
            this.has_day = has_day
            this.modal_toggler = (this.modal_toggler == 0) ? 1 : 0

            $('.recap-produit').modal('show')
        },

        addLot(article_id) {
            this.$store.commit("SET_LOT_ARTICLE_REF_ID", article_id)

            this.$router.push({ path: `/consommables/ajout` });
        },

        printConsomable() {
            this.can_print = true
            this.is_printing = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
                this.is_printing = false
            }, 500);
        }
    }
}


